const alinaAssets = {
  logo: function (width, height, color) {
    return (
      <svg
        version="1.0"
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 1200.000000 455.000000"
        preserveAspectRatio="xMidYMid meet"
      >
        <g
          transform="translate(0.000000,455.000000) scale(0.100000,-0.100000)"
          fill={color}
          stroke="none"
        >
          <path
            d="M10911 4528 c-5 -13 -152 -363 -326 -778 -175 -415 -370 -881 -435
       -1035 l-117 -280 110 -3 c61 -1 116 -1 122 2 6 2 157 373 335 825 179 451 327
       821 330 821 3 0 63 -143 134 -318 72 -174 223 -544 337 -822 l208 -505 114 -3
       115 -3 -118 283 c-65 156 -254 612 -420 1013 -166 402 -311 751 -322 778 -23
       52 -52 63 -67 25z"
          />
          <path
            d="M834 3958 l-241 -573 -115 -3 -115 -3 -38 -87 c-20 -48 -39 -93 -42
       -99 -4 -10 22 -13 110 -13 l114 0 -162 -385 -162 -385 121 0 121 0 157 383
       156 382 113 3 c239 6 446 -71 613 -228 111 -104 145 -159 226 -359 l72 -181
       114 0 114 0 -9 23 c-5 12 -125 301 -266 642 -142 341 -335 807 -430 1035 -136
       330 -176 416 -191 418 -17 2 -52 -75 -260 -570z m420 -309 c90 -222 163 -405
       161 -407 -2 -2 -32 11 -66 29 -139 70 -301 109 -451 109 -68 0 -89 3 -85 13
       13 31 250 625 258 646 5 13 12 22 14 19 3 -2 78 -186 169 -409z"
          />
          <path
            d="M3220 3460 l0 -1050 620 0 620 0 0 100 0 100 -505 0 -505 0 0 950 0
       950 -115 0 -115 0 0 -1050z"
          />
          <path
            d="M5700 3440 l0 -1050 120 0 120 0 0 1050 0 1050 -120 0 -120 0 0
       -1050z"
          />
          <path
            d="M7152 3443 l3 -1048 105 0 105 0 3 700 c2 435 -1 745 -8 819 -6 65
       -9 120 -7 122 1 2 28 -31 59 -74 95 -132 1347 -1587 1368 -1590 20 -3 20 9 20
       1057 l0 1061 -106 0 -105 0 3 -802 c2 -442 7 -811 12 -820 19 -40 -12 -13 -56
       50 -26 37 -337 405 -690 819 -604 707 -645 752 -676 753 l-32 0 2 -1047z"
          />
          <path d="M0 620 l0 -600 75 0 75 0 0 600 0 600 -75 0 -75 0 0 -600z" />
          <path
            d="M3930 620 l0 -600 65 0 65 0 0 61 0 62 46 -43 c94 -86 230 -120 350
       -86 171 49 269 190 281 406 16 297 -159 505 -409 488 -85 -7 -180 -51 -232
       -108 l-36 -40 0 230 0 230 -65 0 -65 0 0 -600z m478 155 c176 -53 250 -338
       137 -530 -87 -149 -315 -165 -448 -31 l-37 37 0 203 0 203 44 41 c92 85 191
       110 304 77z"
          />
          <path d="M4960 620 l0 -600 65 0 65 0 0 600 0 600 -65 0 -65 0 0 -600z" />
          <path
            d="M6840 619 l0 -600 323 3 c366 4 380 7 466 84 154 138 123 416 -56
       504 -29 14 -52 27 -52 30 -1 3 21 17 48 32 89 49 131 130 131 252 0 83 -27
       152 -81 204 -84 83 -132 92 -486 92 l-293 0 0 -601z m577 456 c120 -36 171
       -186 100 -293 -46 -70 -73 -77 -314 -80 l-213 -3 0 195 0 196 188 0 c139 0
       202 -4 239 -15z m43 -529 c76 -40 111 -98 112 -181 1 -73 -17 -118 -61 -158
       -53 -48 -106 -57 -331 -57 l-190 0 0 211 0 211 218 -4 c188 -3 222 -6 252 -22z"
          />
          <path
            d="M2289 1181 c-20 -20 -29 -39 -29 -61 0 -43 47 -90 90 -90 43 0 90 47
       90 90 0 22 -9 41 -29 61 -40 39 -82 39 -122 0z"
          />
          <path
            d="M3529 1181 c-20 -20 -29 -39 -29 -61 0 -43 47 -90 90 -90 43 0 90 47
       90 90 0 22 -9 41 -29 61 -40 39 -82 39 -122 0z"
          />
          <path
            d="M758 891 c-62 -20 -115 -50 -165 -94 l-33 -29 0 61 0 61 -65 0 -65 0
       0 -435 0 -435 65 0 65 0 0 318 0 319 38 38 c59 60 133 90 222 90 88 0 132 -20
       165 -75 19 -33 20 -54 23 -362 l3 -328 65 0 65 0 -3 363 c-3 353 -4 363 -25
       404 -58 107 -207 151 -355 104z"
          />
          <path
            d="M2857 899 c-166 -39 -259 -191 -198 -324 37 -82 105 -120 302 -170
       174 -44 225 -83 216 -165 -17 -152 -286 -176 -456 -40 l-38 29 -33 -45 -32
       -45 28 -30 c68 -71 224 -116 363 -106 102 7 161 30 220 83 99 89 109 231 24
       325 -47 52 -91 74 -211 105 -171 44 -220 63 -247 95 -30 36 -32 73 -5 116 26
       44 72 65 151 71 88 6 189 -24 244 -72 l40 -34 27 42 c35 51 35 57 0 83 -107
       79 -267 112 -395 82z"
          />
          <path
            d="M5635 897 c-233 -60 -370 -310 -310 -565 20 -84 48 -135 107 -199 57
       -60 141 -106 226 -124 67 -14 184 -7 258 16 56 16 174 88 174 105 0 17 -51 80
       -65 80 -6 0 -20 -8 -29 -19 -9 -10 -45 -32 -79 -47 -54 -25 -74 -28 -152 -28
       -78 0 -97 3 -141 26 -73 38 -130 107 -154 186 -11 35 -20 68 -20 73 0 5 151 9
       350 9 l350 0 0 58 c0 181 -109 356 -257 412 -71 27 -189 34 -258 17z m191
       -112 c94 -28 173 -125 190 -232 l7 -43 -287 0 c-161 0 -286 4 -286 9 0 5 9 38
       20 73 50 161 197 241 356 193z"
          />
          <path
            d="M8271 890 c-61 -22 -68 -27 -133 -89 l-48 -45 0 67 0 67 -65 0 -65 0
       0 -435 0 -435 65 0 65 0 0 314 0 313 46 43 c59 54 125 83 191 84 l53 1 0 68
       c0 67 0 67 -27 67 -16 -1 -52 -9 -82 -20z"
          />
          <path
            d="M8751 895 c-62 -18 -131 -54 -181 -94 -37 -31 -37 -40 9 -100 l18
       -23 54 41 c65 49 130 71 216 71 96 0 164 -35 200 -104 18 -34 31 -226 16 -226
       -5 0 -20 11 -32 24 -36 38 -133 76 -211 83 -200 17 -345 -101 -344 -282 0
       -120 54 -203 163 -253 114 -52 275 -34 375 43 26 19 48 35 51 35 3 0 5 -20 5
       -45 l0 -45 65 0 65 0 0 323 c0 380 -3 401 -79 477 -29 29 -66 53 -96 64 -69
       25 -224 30 -294 11z m246 -458 c77 -40 93 -65 93 -152 0 -87 -16 -112 -93
       -152 -39 -19 -72 -27 -129 -31 -69 -4 -84 -2 -132 22 -145 71 -140 258 9 328
       59 28 182 21 252 -15z"
          />
          <path
            d="M9767 900 c-194 -49 -327 -230 -327 -445 0 -223 138 -403 341 -446
       69 -15 180 -6 249 20 56 21 150 93 150 115 0 6 -18 29 -39 50 l-39 38 -35 -34
       c-55 -56 -101 -73 -192 -73 -129 0 -206 52 -264 175 -22 48 -26 68 -26 155 0
       89 3 107 28 160 35 74 67 109 131 142 105 54 238 38 316 -38 l42 -41 39 38
       c21 21 39 44 39 50 0 22 -93 94 -150 115 -63 24 -202 34 -263 19z"
          />
          <path
            d="M10655 897 c-233 -60 -370 -310 -310 -565 20 -84 48 -135 107 -199
       57 -60 141 -106 226 -124 67 -14 184 -7 258 16 56 16 174 88 174 105 0 17 -51
       80 -65 80 -6 0 -20 -8 -29 -19 -9 -10 -45 -32 -79 -47 -54 -25 -74 -28 -152
       -28 -78 0 -97 3 -141 26 -73 38 -130 107 -154 186 -11 35 -20 68 -20 73 0 5
       151 9 350 9 l350 0 0 58 c0 181 -109 356 -257 412 -71 27 -189 34 -258 17z
       m191 -112 c94 -28 173 -125 190 -232 l7 -43 -287 0 c-161 0 -286 4 -286 9 0 5
       9 38 20 73 50 161 197 241 356 193z"
          />
          <path
            d="M11547 899 c-166 -39 -259 -191 -198 -324 37 -82 105 -120 302 -170
       174 -44 225 -83 216 -165 -17 -152 -286 -176 -456 -40 l-38 29 -33 -45 -32
       -45 28 -30 c68 -71 224 -116 363 -106 102 7 161 30 220 83 99 89 109 231 24
       325 -47 52 -91 74 -211 105 -171 44 -220 63 -247 95 -30 36 -32 73 -5 116 26
       44 72 65 151 71 88 6 189 -24 244 -72 l40 -34 27 42 c35 51 35 57 0 83 -107
       79 -267 112 -395 82z"
          />
          <path
            d="M1377 663 c52 -126 133 -322 180 -436 l86 -208 75 3 74 3 174 420
       c96 231 176 426 179 433 3 9 -14 12 -69 12 l-74 0 -143 -357 c-136 -341 -143
       -356 -155 -328 -6 17 -71 177 -144 358 l-132 327 -73 0 -73 0 95 -227z"
          />
          <path d="M2290 455 l0 -435 65 0 65 0 0 435 0 435 -65 0 -65 0 0 -435z" />
          <path d="M3530 455 l0 -435 65 0 65 0 0 435 0 435 -65 0 -65 0 0 -435z" />
        </g>
      </svg>
    );
  },
};

export default alinaAssets;
